import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {ContactUser} from "../models/ContactUser";

@Injectable({
  providedIn: 'root'
})
export class ContactUserService {
  private apiUrl = environment.apiUrl;

  constructor(public http: HttpClient) {}

  save(contactUser: ContactUser): Observable<ContactUser> {
    return this.http.post<ContactUser>(`${this.apiUrl}/contacts`, contactUser);
  }
}
